import { DebouncedInput } from "@altimateai/lego";
import { useSearchParams } from "react-router-dom";
import { useTags } from "../useTags";
import { SearchIcon } from "@/assets/icons";

const SearchTags = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search } = useTags({ mode: "paginated" });

  const handleSearchChange = (value: string) => {
    searchParams.set("search", value);
    searchParams.set("page", "1"); // Reset to first page when searching
    setSearchParams(searchParams);
  };

  return (
    <div className="al-max-w-sm">
      <DebouncedInput
        type="search"
        placeholder="Search tags..."
        value={search}
        onChange={handleSearchChange}
        debounceMs={300}
        icon={SearchIcon}
        iconPosition="left"
      />
    </div>
  );
};

export default SearchTags;
